<template>
	<div>
		<ModalHeader :title="getString('vat_nature_btn')" :button-text="getString('apply')" @click-button="apply" />
		<AppList :items="items" />
	</div>
</template>

<script>
import ModalHeader from "@/console-new/components/shared/ModalHeader.vue";
import AppList from "@/shared/components/AppList.vue";
import {useLanguageStore} from "@/shared/stores";
import {useEpsonStore, useMenuStore, useUserStore} from "@/console-new/stores";

export default {
	setup() {
		let languageStore = useLanguageStore();
		let epsonStore = useEpsonStore();
		let menuStore = useMenuStore();
		let userStore = useUserStore();
		return {getString: languageStore.getString, epsonStore, menuStore, userStore};
	},
	name: "VatNatureBottomSheet",
	components: {ModalHeader, AppList},
	emits: ["apply"],
	data() {
		return {
			nature: null
		}
	},
	props: {
		categoryTempId: {
			type: String,
			required: true
		}
	},
	computed: {
		category() {
			return this.menuStore.modMenu.categories[this.categoryTempId];
		},
		vatNatures() {
			let natures = this.epsonStore.countryVatsNature["IT"];
			if (this.userStore.currBusiness && this.epsonStore.countryVatsNature.hasOwnProperty(this.userStore.currBusiness.country)) {
				natures = this.epsonStore.countryVatsNature[this.userStore.currBusiness.country];
			}
			return natures;
		},
		items() {
			let natures = Object.keys(this.vatNatures);
			let currNature = this.nature ?? natures[0];

			return natures.map(nature => {
				return {
					title: nature,
					switch: true,
					active: nature === currNature,
					callback: () => {
						this.nature = nature;
					}
				}
			});
		}
	},
	methods: {
		apply() {
			if(this.nature === null) {
				this.nature = Object.keys(this.vatNatures)[0];
			}
			this.$emit('apply', this.nature);
		}
	}
}
</script>

<style scoped lang="scss">

</style>